import AbstractWrapperElement from './AbstractWrapperElement';

export default class PageElementWrapper extends AbstractWrapperElement {
  constructor(private htmlElement, private iframeElement) {
    super();
  }

  updateElementPosition(
    pos: {
      top: number;
      left: number;
      width: number;
      height: number;
    },
    iframeRect
  ): void {
    let top = pos.top + iframeRect.top;
    let left = pos.left + iframeRect.left;
    let height = pos.height;
    let width = pos.width;

    // Clip top
    if (top < iframeRect.top) {
      height -= iframeRect.top - top;
      top = iframeRect.top;
    }

    // Clip bottom
    const bottom = top + height;
    const iframeBottom = iframeRect.top + iframeRect.height;
    if (bottom > iframeBottom) {
      height -= bottom - iframeBottom;
    }

    // Clip left
    if (left < iframeRect.left) {
      width -= iframeRect.left - left;
      left = iframeRect.left;
    }

    // Clip right
    const right = left + width;
    const iframeRight = iframeRect.left + iframeRect.width;
    if (right > iframeRight) {
      width -= right - iframeRight;
    }

    // Hide if completely outside iframe bounds
    if (height <= 0 || width <= 0) {
      this.htmlElement.style.display = 'none';
    } else {
      this.htmlElement.style.display = 'block';
      this.htmlElement.style.top = top + 'px';
      this.htmlElement.style.left = left + 'px';
      this.htmlElement.style.width = width + 'px';
      this.htmlElement.style.height = height + 'px';
    }
  }
}
